module.exports = __webpack_public_path__ + "assets/RhombusInTriangle.a7cd34d86270a93944e4e18866cd18b8.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/RhombusInTriangle.gmt
// module id = 989
// module chunks = 0